import script from "./TranscriberUploadPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TranscriberUploadPage.vue?vue&type=script&setup=true&lang=js"

import "./TranscriberUploadPage.vue?vue&type=style&index=0&id=3b7523fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b7523fa"]])

export default __exports__